var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCreditCard = function SvgCreditCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9736"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h48v48H0z",
    "data-name": "Rectangle 25290"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9735"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.355 32.578H8.118v-2h11.237Z",
    "data-name": "Line 1854"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.907 32.578h-5.079v-2h5.079Z",
    "data-name": "Line 1855"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.264 40.518H6.197a3.78 3.78 0 0 1-3.774-3.774v-24.97A3.78 3.78 0 0 1 6.197 8h36.067a3.78 3.78 0 0 1 3.774 3.774v24.97a3.78 3.78 0 0 1-3.774 3.774M6.197 10a1.776 1.776 0 0 0-1.774 1.774v24.97a1.776 1.776 0 0 0 1.774 1.774h36.067a1.776 1.776 0 0 0 1.774-1.774v-24.97A1.776 1.776 0 0 0 42.264 10Z",
    "data-name": "Path 5261"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.961 16.184h42.078v7.184H2.961z",
    "data-name": "Rectangle 5099"
  })))));
};
export { SvgCreditCard as ReactComponent };
export default "/_next/static/images/credit-card.svg";